import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'

function Footer() {
        const [isVisible, setIsVisible] = useState(false);
      
        const handleScroll = () => {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          setIsVisible(scrollTop > 200);
        };
      
        const scrollToTop = () => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
           
          });
        };
      
        useEffect(() => {
          window.addEventListener('scroll', handleScroll);
          return () => {
            window.removeEventListener('scroll', handleScroll);
          };
        }, []);

        const currentYear = new Date().getFullYear();
      
  return (
    <>
      <footer className="footer section-padding">
        <div className="second-footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 widget-area">
                        <div className="footer-logo">
                            <Link to="/"><img src="/tm/react/toolways/assets/images/logo.png" className="image-fit" alt="logo"/></Link>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 widget-area">
                        <div className="widget widget_text">
                            <ul className="widget_info_text">
                                <li>
                                    <i className="fas fa-map-marker-alt"></i> 
                                    <strong>Our Main Branch</strong>
                                    <p>NewYork City,United States</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 widget-area">
                        <div className="widget widget_text">
                            <ul className="widget_info_text">
                                <li>
                                    <i className="fa fa-envelope"></i> 
                                    <strong>Email US</strong>
                                    <p>Info@example.com</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 widget-area">
                        <div className="widget widget_text">
                            <ul className="widget_info_text">
                                <li>
                                    <i className="fa fa-phone"></i> 
                                    <strong>Call Us</strong>
                                    <p>+123-456-7890 / 91</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-3 col-sm-4">
                    <div className="ft_widget border-sm-0 pl-sm-0">
                        <h6 className="ft_title">About Us</h6>
                        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem </p>
                        <p className="mb-2">Follow Us:</p>
                        <ul className="ft_social">
                            <li>
                                <Link to="#" style={{ borderRadius: '8px 0px 0px 8px' }}>
                                    <i className="fab fa-facebook-f"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fab fa-x-twitter"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="#" style={{ borderRadius: '0px 8px 8px 0px' }}>
                                    <i className="fab fa-instagram"></i>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-xl-3 col-sm-4">
                    <div className="ft_widget">
                        <h6 className="ft_title">Help Center</h6>
                        <ul className="ft_menu">
                            <li>
                                <Link to="/payment">Payments</Link>
                            </li>
                            <li>
                                <Link to="#">Shipping</Link>
                            </li>
                            <li>
                                <Link to="#">Product Returns</Link>
                            </li>
                            <li>
                                <Link to="/faqs">FAQ's</Link>
                            </li>
                            <li>
                                <Link to="/checkout">Checkout</Link>
                            </li>
                            <li>
                                <Link to="/blog">Blog</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-xl-3 col-sm-4">
                    <div className="ft_widget">
                        <h6 className="ft_title">Useful Links</h6>
                        <ul className="ft_menu">
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/contact">Contact</Link>
                            </li>
                            <li>
                                <Link to="/about">About</Link>
                            </li>
                            <li>
                                <Link to="/terms-conditions">Terms & Conditions</Link>
                            </li>
                            <li>
                                <Link to="/privacy">Policy</Link>
                            </li>
                            <li>
                                <Link to="/order">My Orders</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-xl-3 col-sm-4">
                    <div className="ft_widget">
                        <h6 className="ft_title">Contact Us</h6>
                        <p className="mb-3">Sed ut perspiciatis unde omnis iste natus error sit voluptatem </p>
                        <img src="/tm/react/toolways/assets/images/footer_map.png" alt='img'/>
                    </div>
                </div>
            </div>
        </div>
      </footer>
        <div className="container-fluid copyright">
          <div className="row">
            <div className="col-md-6">
                <div className="copyright-text">
                    <p className="mb-0">@Copyright {currentYear}. <Link to="#" className="thm-color-one">Website.com</Link> All Rights Reserved</p>
                </div>  
            </div>
            <div className="col-md-6">
                <div className="money-card">
                    <ul className="money-cards">
                        <li>
                            <img src="/tm/react/toolways/assets/images/card-1.png" alt='img'/>
                        </li>
                        <li>
                            <img src="/tm/react/toolways/assets/images/card-2.png" alt='img'/>
                        </li>
                        <li>
                           <img src="/tm/react/toolways/assets/images/card-3.png" alt='img'/>
                        </li>
                        <li>
                            <img src="/tm/react/toolways/assets/images/card-4.png" alt='img'/>
                        </li>
                        <li>
                            <img src="/tm/react/toolways/assets/images/card-5.png" alt='img'/>
                        </li>
                        <li>
                            <img src="/tm/react/toolways/assets/images/card-6.png" alt='img'/>
                        </li>
                    </ul>
                </div>
            </div>
         </div>
        </div>
        {/* <Link to="#" data-target="html" className="back-to-top ft-sticky">
            <i className="fal fa-long-arrow-up"></i>
        </Link> */}
        <button className={`back-to-top ft-sticky go-to-top-button  ${isVisible ? 'visible' : ''}`} onClick={scrollToTop}>
        <div data-target="html" className="">
            <i className="fal fa-long-arrow-up"></i>
        </div>
        </button>
    </>
  )
}

export default Footer